import React from 'react';

const RavenRadonIcon = (): React.ReactElement => (
    <svg className="device-svg-icons" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15 12.9C15 10.7461 16.7461 9 18.9 9H29.1C31.2539 9 33 10.7461 33 12.9V24.6C33 26.7539 31.2539 28.5 29.1 28.5H18.9C16.7461 28.5 15 26.7539 15 24.6V12.9ZM18.9 12C18.4029 12 18 12.4029 18 12.9V24.6C18 25.0971 18.4029 25.5 18.9 25.5H29.1C29.5971 25.5 30 25.0971 30 24.6V12.9C30 12.4029 29.5971 12 29.1 12H18.9Z"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M31.5 3C35.6421 3 39 6.35786 39 10.5V37.5C39 41.6421 35.6421 45 31.5 45H16.5C12.3579 45 9 41.6421 9 37.5V10.5C9 6.35786 12.3579 3 16.5 3H31.5ZM36 10.5C36 8.01472 33.9853 6 31.5 6H16.5C14.0147 6 12 8.01472 12 10.5V37.5C12 39.9853 14.0147 42 16.5 42H31.5C33.9853 42 36 39.9853 36 37.5V10.5Z"
        />
        <path d="M26.25 33.75C26.25 34.9926 25.2426 36 24 36C22.7574 36 21.75 34.9926 21.75 33.75C21.75 32.5074 22.7574 31.5 24 31.5C25.2426 31.5 26.25 32.5074 26.25 33.75Z" />
    </svg>
);
export default RavenRadonIcon;
